function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.00016 8.16667H8.00016M6.00016 6.16667L6.00016 10.1667M9.3335 13.5H2.66683C1.93045 13.5 1.3335 12.903 1.3335 12.1667V2.83333C1.3335 2.09695 1.93045 1.5 2.66683 1.5H6.39069C6.5675 1.5 6.73707 1.57024 6.86209 1.69526L10.4716 5.30474C10.5966 5.42976 10.6668 5.59933 10.6668 5.77614V12.1667C10.6668 12.903 10.0699 13.5 9.3335 13.5Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgAddFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0.58 0.75 10.83 13.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFile);
export default __webpack_public_path__ + "static/media/add-file.0ecba937.svg";
export { ForwardRef as ReactComponent };